import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { AlloxCommonAsyncPipe, IAlloxAsyncPipeFetch, IAlloxAsyncPipeOption } from './allox-common-async.pipe';
import { OSGroup, OSGroupService } from '@app/core';

interface IOSGroupPipeOption extends IAlloxAsyncPipeOption {
  name?: boolean;
}
@Pipe({
    name: 'osGroup', pure: false,
    standalone: false
})
export class OSGroupPipe
  extends AlloxCommonAsyncPipe<OSGroup>
  implements IAlloxAsyncPipeFetch<OSGroup>, PipeTransform {

  constructor(private service: OSGroupService, changeDetectorRef: ChangeDetectorRef, router: Router) {
    super(changeDetectorRef, router);
  }

  fetchDependency(value: number) {
    return this.service.fetch(value);
  }

  makeText(value: number, obj: OSGroup, option?: IOSGroupPipeOption) {
    if (!obj) {
      return `Unknown [id: ${value}]`;
    }
    return obj.name;
  }

}
